export interface SandboxRequest {
  method: string;
  path: string;
  body?: unknown;
  idempotencyKey?: string;
}

export interface SandboxResponse {
  ok: boolean;
  status: number;
  statusText: string;
  latencyMs: number;
  body: unknown;
}

export function getDeveloperAccessKey(): string {
  return localStorage.getItem("facio_dev_key") || "";
}

export function createIdempotencyKey(prefix = "docs"): string {
  const randomPart = globalThis.crypto?.randomUUID?.() || Math.random().toString(36).slice(2);
  return `${prefix}_${randomPart}`;
}

export async function runSandboxRequest(request: SandboxRequest): Promise<SandboxResponse> {
  const startedAt = performance.now();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "x-api-key": getDeveloperAccessKey(),
    "x-tenant-id": localStorage.getItem("facio_dev_tenant") || "tenant_default"
  };

  if (request.idempotencyKey) {
    headers["x-idempotency-key"] = request.idempotencyKey;
  }

  const response = await fetch(`/api/sandbox${request.path}`, {
    method: request.method,
    headers,
    body: request.body === undefined ? undefined : JSON.stringify(request.body)
  });
  const text = await response.text();
  const body = text ? safeJsonParse(text) : null;

  return {
    ok: response.ok,
    status: response.status,
    statusText: response.statusText,
    latencyMs: Math.round(performance.now() - startedAt),
    body
  };
}

function safeJsonParse(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}
